import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const TenantUsersBannerSlot = styled.div`
    margin-bottom: ${owcTheme['one-spacing-gap-xs']};
`;
